import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseUrl';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});

//Declare other api here (Ex google maps etc.)
